import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import UseScrollAnimation from "../../Elements/ScrollAnimation";

function ReadySchedule() {
  UseScrollAnimation(); // ✅ just call it

  return (
    <section className="Ready_Section">
      <div className="Ready_SectionBox">
        <span className="Ready_Section_Title animate-top">
          Begin your journey
        </span>
        <h2 className="Ready_Section_Heading animate-top">
          Ready to{" "}
          <span className="Ready_Section_HeadingItalic">feel truly well?</span>
        </h2>
        <p className="Ready_Section_Content animate-top">
          Schedule your first consultation today. Telehealth appointments
          available — care delivered with patience, wherever you are.
        </p>
        <Link to="/contact-us" className="Ready_Section_Button01 animate-top">
          <span>Schedule now</span>
          <ArrowRight className="Ready_Section_Button01_ArrowRight" />
        </Link>
      </div>
    </section>
  );
}

export default ReadySchedule;
